/** @format */
import { CategoryBlockVariant } from './types';

export const getBackground = (variant?: CategoryBlockVariant) =>
    variant === CategoryBlockVariant.MIDNIGHT
        ? 'radial-gradient(ellipse at top left, var(--colors-brand-primary-hover) 0%, var(--colors-brand-primary) 100%)'
        : 'var(--colors-surface-primary)';
